<template>
  <div class="body">
    <h1>{{title}}</h1>
    <p>{{author}}<br>
      <span>
        <font color="#979A9A">{{create_date}}</font>
      </span>
    </p>
    <div v-html="content"></div>
    <el-divider></el-divider>
    <h2 id="HotComment">热门评论</h2>
    <div v-for="(item,i) in comments" :key="i" class="comment">
      <el-avatar class="header-img" :size="40" :src="item.user_head"></el-avatar>
      <span class="author-name">{{item.user_name}}</span>
      <div class="comment-like">
        <font color="#979A9A"><strong>{{item.like_num}}</strong></font>&nbsp;
        <transition :name=" item.isLike ? 'zoom' : '' " mode="out-in">
          <img src="../../assets/unlike.png" v-if="item.isLike" key="like" width="20px" @click="commentLike(item)" />
          <img src="../../assets/like.png" v-else key="unlike" width="20px" @click="commentLike(item)" />
        </transition>
      </div>
      <div class="talk-box">
        <span class="reply">{{item.content}}</span>
      </div>
      <div class="comment-time">
        <span><font color="#979A9A">{{item.create_time}}</font></span>
        <span>回复</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Global from "../Global";

  export default {
    name: 'News',
    props: ['news_id'],
    data() {
      return {
        author: '',
        title: '',
        content: '',
        create_date: '',
        cover_url: '',
        comments: [],
      }
    },
    mounted() {
      this.getNews(this.news_id);
      this.getComments(this.news_id);
    },
    methods: {
      getNews(news_id) {
        let that = this;
        that.axios({
            method: 'GET',
            url: Global.accountUrl + '/news/findNews?news_id=' + that.news_id,
          })
          .then(function (response) {
            if (response.data.code == 1000) {
              let res = response.data.data;
              that.author = res.author;
              that.title = res.title;
              that.content = res.content;
              that.create_date = that.set_time(res.create_date);
              that.cover_url = res.cover_url;
            } else {
              that.$message.error(response.data.data);
            }
          })
      },
      getComments(news_id) {
        let that = this;
        that.axios({
            method: 'GET',
            url: Global.accountUrl + '/news/getCommentByNewsId?news_id=' + that.news_id,
          })
          .then(function (response) {
            if (response.data.code == 1000) {
              let res = response.data.data;
              // 此处只取所有评论点赞最高的前四个数据
              for (let i = 0; i < 4; i++) {
                that.isLike = response.data.data;
                // 创建一个评论对象
                let comment = {
                  comment_id: res[i].comment_id,
                  user_id: res[i].user_id,
                  user_name: res[i].user_name,
                  user_head: res[i].user_head,
                  content: res[i].content,
                  like_num: res[i].like_num,
                  create_time: res[i].create_time,
                  isLike: false
                }
                that.comments.push(comment);
              }
            } else {
              that.$message.error(response.data.data);
            }
          })
      },
      commentLike(row) {
        if (row.isLike == true) {
          row.isLike = false;
          row.like_num = row.like_num - 1;
        } else {
          row.isLike = true;
          row.like_num = row.like_num + 1;
        }
      },
      set_time(str) {
        var n = parseInt(str);
        var date = new Date(n); //获取一个时间对象

        let Y = date.getFullYear() + '-'; // 获取完整的年份(4位,1970)
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) +
          '-'; // 获取月份(0-11,0代表1月,用的时候记得加上1)
        let D = date.getDate() + ' '; // 获取日(1-31)
        let h = date.getHours() + ':'; // 获取小时数(0-23)
        let m = date.getMinutes(); // 获取分钟数(0-59)
        let s = date.getSeconds(); // 获取秒数(0-59)
        return Y + M + D + h + m;
      }
    },
  }

</script>

<style>
  .body {
    margin: 25px;
  }

  #HotComment {
    text-align: center;
    color: #409EFF;
  }

  .comment {
    position: relative;
    margin: 25px 0;
  }

  .header-img {
    display: inline-block;
    vertical-align: top;
  }

  .author-name {
    position: relative;
    /* left: 5px; */
  }

  .comment-like {
    position: absolute;
    top: 0;
    right: 0;
  }

  .comment-time {
    margin: 0px 45px;
  }

  .talk-box {
    margin: 20px 20px 20px 45px;
  }

  /** 动画进行时的class **/
  .zoom-enter-active,
  .zoom-leave-active {
    transition: all .15s cubic-bezier(0.42, 0, 0.34, 1.55);
  }

  /** 设置进场开始的状态和离场结束的状态，都是缩放到0 **/
  .zoom-enter,
  .zoom-leave-to {
    transform: scale(0);
  }

  /** 设置进场结束的状态和离场开始的状态, 都是缩放到1 **/
  .zoom-enter-to,
  .zoom-leave {
    transform: scale(1);
  }

</style>



// WEBPACK FOOTER //
// src/components/news/News.vue